module.exports = __webpack_public_path__ + "static/media/wc5.221b2af9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/photos/wc5.jpg
// module id = 218
// module chunks = 0